// extracted by mini-css-extract-plugin
module.exports = {"rightWrapper":"LoginSignUp_rightWrapper__2dh08","buttonWrapper":"LoginSignUp_buttonWrapper__1t6-P","button":"LoginSignUp_button__7Hm9b","text":"LoginSignUp_text__2XkJY"};